import {
  LeadClaimedByFacility,
  LeadScreenerLeadInfoState
} from '@/types/crm-screener';
import {
  LeadScreenerLeadInfo,
  LeadScreenerLeadInfoContactMethodPreferenceEnum,
  LeadScreenerLeadInfoMaritalStatusEnum,
  LeadScreenerLeadInfoReligionEnum
} from '@/types/crm-screener/models/LeadScreenerLeadInfo';
import { MatrixCarePatientMaritalStatusEnum } from '@/types/crm-screener-api';

export const MaritalStatusToDisplayValueMapping: Record<
  LeadScreenerLeadInfoMaritalStatusEnum | MatrixCarePatientMaritalStatusEnum,
  string
> = {
  single: 'Single',
  domestic_partner: 'Domestic Partner',
  married: 'Married',
  separated: 'Separated',
  divorced: 'Divorced',
  widowed: 'Widowed',
  unknown_declined: 'Unknown / Declined To Answer'
};

export const MaritalStatusSelectOptions = Object.entries(
  MaritalStatusToDisplayValueMapping
).map(([key, value]) => ({
  label: value,
  value: key
}));

export class LeadInfoModel implements LeadScreenerLeadInfo {
  contact_method_preference?:
    | LeadScreenerLeadInfoContactMethodPreferenceEnum
    | undefined;
  current_address?: string | undefined;
  email?: string | undefined;
  id?: string | undefined;
  marital_status?: LeadScreenerLeadInfoMaritalStatusEnum | undefined;
  phone_number?: string | undefined;
  photo_url?: string | undefined;
  primary_language?: string | undefined;
  s3_photo_key?: string | undefined;
  race?: LeadClaimedByFacility | undefined;
  race_id?: string | undefined;
  religion?: LeadScreenerLeadInfoReligionEnum | undefined;
  state?: LeadScreenerLeadInfoState | undefined;
  state_id?: string | undefined;
  constructor(payload: LeadScreenerLeadInfo) {
    Object.assign(this, payload);
  }

  public getMaritalStatusDisplayValue(): string | null {
    if (!this.marital_status) {
      return null;
    }
    return MaritalStatusToDisplayValueMapping[this.marital_status];
  }
}
